import PropTypes from 'prop-types'
import { grantedRightLevelPropType } from './granted-right-level-prop-type'

/**
 * WASAPI type.
 *
 * @typedef {Object} GrantedRightLevelList
 * @property {GrantedRightLevel[]} [grantedRightLevels]
 * @property {string} [profileId]
 */

export const grantedRightLevelListPropType = PropTypes.shape({
    grantedRightLevels: PropTypes.arrayOf(grantedRightLevelPropType),
    profileId: PropTypes.string
})
